import { render, staticRenderFns } from "./DashboardFatturato.vue?vue&type=template&id=47a87f20&scoped=true&"
import script from "./DashboardFatturato.vue?vue&type=script&lang=js&"
export * from "./DashboardFatturato.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFatturato.vue?vue&type=style&index=0&id=47a87f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a87f20",
  null
  
)

export default component.exports